import React, { useState } from 'react';
import styles from './CollapseMenu.module.scss';
import Text from '../Text';

interface Props {
	children: React.ReactElement | React.ReactElement[];
}

const CollapseMenu: React.FC<Props> = ({ children }) => {
	const [isCollapsed, setIsCollapsed] = useState(false);

	return (
		<div className={styles.wrapper}>
			<div
				className={styles.toggleButton}
				onClick={() => setIsCollapsed(prev => !prev)}
			>
				<Text
					tx={
						isCollapsed ? 'layout.profileMenu.less' : 'layout.profileMenu.more'
					}
					className={styles.text}
					firstUpper
				/>
				<div>
					<img src='/dist/patientV3/icons/arrow-up-purple-small.svg' />
				</div>
				<div className={styles.line} />
			</div>
			{isCollapsed && <div className={styles.content}>{children}</div>}
		</div>
	);
};

export default CollapseMenu;
